export const delegate = {
  state: { delegate: [] },
  reducers: {
    fetchStart: (state, { supportScreen }) => ({
      ...state,
      delegate: supportScreen,
    }),
  },
};
